import { MutationResult } from '@apollo/react-common';
import { DataProxy } from 'apollo-cache';
import objectValues from 'lodash/values';

import { Wws_PageItem } from '../../../generated/graphql';
import filter, { Transformer } from '../../../helpers/filter';
import addItemToPage from '../../../helpers/apolloCache/addItemToPage';
import { Attributes, InitialValues } from './Form';
import { pagesQuery } from '../../LeftContainer/graphql';

export type CreateSaveArgs = {
  update: Function;
  create: Function;
  pageId: number;
  itemId: number | null;
  close: (pageItem?: Wws_PageItem) => void;
  fields: string[];
  onSaveHandler?: Function;
};

export interface Save {
  (values: InitialValues): Promise<void>;
}

export const nullifyEmpties: Transformer = v => (v === '' ? null : v);

export function createSave<T, Z extends MutationResult>({
  update,
  create,
  pageId,
  itemId,
  close,
  fields,
  onSaveHandler,
}: CreateSaveArgs): Save {
  return async (values: InitialValues): Promise<void> => {
    const { mediaUrl, aspectRatio, __typename, ...rest } = values.photo;

    const photoData = {
      photo: {
        ...rest,
      },
    };

    const attrs: Attributes = {
      name: values.name,
      pageId: pageId,
    };

    const optional = filter<InitialValues>(values, fields, nullifyEmpties);

    if (itemId) {
      await update({
        variables: {
          attributes: {
            ...attrs,
            ...optional,
            id: itemId,
            ...photoData,
          },
        },
        update: (_cache: DataProxy, { data }: Z) => close(objectValues(data || {}).pop()),
      });
    } else {
      await create({
        variables: { attributes: { ...attrs, ...optional, ...photoData } },
        update: (cache: DataProxy, { data }: Z) => {
          addItemToPage<T>(cache, pageId, data?.item, close);
        },
        refetchQueries: [{ query: pagesQuery }],
      });
    }
    if (onSaveHandler) {
      onSaveHandler();
    }
  };
}
